import React from 'react'
import styled from 'styled-components'

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background: #ffffff;
  box-shadow: ${({ theme }) => theme.shadow(1)};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`

const WrapperHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
`

const HeaderTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    display: none;
  }
`

const HeaderSubtitle = styled.h2`
  font-size: 1.2rem;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.darkGrey};
  margin: 0;
`

const WrapperHeaderSubtitleAlign = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
`

const WrapperHeaderFilter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 100%;
  }
`

interface PageHeaderProps {
  title: string
  subtitle: string
  extraContent?: React.ReactNode
  children?: React.ReactNode
}

export default function PageHeader({ title, subtitle, children, extraContent }: PageHeaderProps) {
  return (
    <Header>
      <WrapperHeaderText>
        <HeaderTitle>{title}</HeaderTitle>
        <WrapperHeaderSubtitleAlign>
          <HeaderSubtitle>{subtitle}</HeaderSubtitle>
          {extraContent}
        </WrapperHeaderSubtitleAlign>
      </WrapperHeaderText>
      <WrapperHeaderFilter>{children}</WrapperHeaderFilter>
    </Header>
  )
}
